import { ICartEntryType } from './types';
import type { ICartEntryOffer, ICartEntryReward, ILegacyCartEntry } from './types';

type IGetItemIdGetterMap = {
  [key in Exclude<ICartEntryType, ICartEntryType.LEGACY_OFFER>]: (ce: ILegacyCartEntry) => string;
};

const itemIdGetterMap: IGetItemIdGetterMap = {
  [ICartEntryType.REWARD]: (ce: ICartEntryReward) => ce.details.reward._id,
  [ICartEntryType.OFFER]: (ce: ICartEntryOffer) => ce.details.offer._id,
};

const getCartEntryItemId = (cartEntry: ILegacyCartEntry) =>
  itemIdGetterMap[cartEntry.type](cartEntry);

export const isCartEntryEqual = (
  cartEntry: ILegacyCartEntry,
  cartEntryToCompare: ILegacyCartEntry
) =>
  cartEntry.referenceId === cartEntryToCompare.referenceId ||
  (cartEntry.type === cartEntryToCompare.type &&
    getCartEntryItemId(cartEntry) === getCartEntryItemId(cartEntryToCompare));
